import {
  BookOpenCheck,
  Building2,
  ClipboardCheck,
  FileText,
  ShieldCheck,
} from "lucide-react";

import jsPDF from "jspdf";
import "jspdf-autotable";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Business License Analysis Report", 40, yPos);
    yPos += 40;

    // Business Entity Profile
    doc.setFontSize(14);
    doc.text("Business Entity Profile", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Legal Entity Name: ${data.businessEntity?.legalName || data.business?.legalName || 'N/A'}`, 40, yPos);
    doc.text(`Trade Name: ${data.businessEntity?.tradeName || data.business?.tradeName || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Proprietor: ${data.businessEntity?.proprietor || data.business?.owner || 'N/A'}`, 40, yPos);
    doc.text(`Constitution Type: ${data.businessEntity?.constitutionType || data.business?.type || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Nature of Business: ${data.businessEntity?.natureOfBusiness || data.business?.nature || 'N/A'}`, 40, yPos);
    doc.text(`Date of Establishment: ${data.businessEntity?.dateOfEstablishment || data.business?.establishmentDate || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`PAN: ${data.businessEntity?.pan || data.business?.pan || 'N/A'}`, 40, yPos);
    yPos += 15;
    doc.text(`Business Address: ${data.businessEntity?.businessAddress || data.business?.address || 'N/A'}`, 40, yPos);
    yPos += 30;

    // GST Registration Analysis
    doc.setFontSize(14);
    doc.text("GST Registration Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`GSTIN: ${data.gstAnalysis?.gstin || 'N/A'}`, 40, yPos);
    doc.text(`Jurisdiction: ${data.gstAnalysis?.jurisdiction || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Status: ${data.gstAnalysis?.status || 'N/A'}`, 40, yPos);
    doc.text(`Registration Type: ${data.gstAnalysis?.registrationType || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Return Compliance: ${data.gstAnalysis?.returnCompliance || 'N/A'}`, 40, yPos);
    doc.text(`Turnover: Rs ${data.gstAnalysis?.turnover || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Date of Registration: ${data.gstAnalysis?.dateOfRegistration || 'N/A'}`, 40, yPos);
    doc.text(`Branches: ${data.gstAnalysis?.branches || 'N/A'}`, 300, yPos);
    yPos += 30;

    // MSME/Udyam Certificate Analysis
    doc.setFontSize(14);
    doc.text("MSME/Udyam Certificate Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Udyam No.: ${data.udyamAnalysis?.udyamNumber || 'N/A'}`, 40, yPos);
    doc.text(`Sector: ${data.udyamAnalysis?.sector || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Date of Issue: ${data.udyamAnalysis?.dateOfIssue || 'N/A'}`, 40, yPos);
    doc.text(`PAN Linked: ${data.udyamAnalysis?.panLinked || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Classification: ${data.udyamAnalysis?.classification || 'N/A'}`, 40, yPos);
    doc.text(`Business Activity: ${data.udyamAnalysis?.businessActivity || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Trade/Municipal License Analysis
    doc.setFontSize(14);
    doc.text("Trade/Municipal License Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`License No: ${data.tradeLicenseAnalysis?.licenseNumber || 'N/A'}`, 40, yPos);
    doc.text(`Validity: ${data.tradeLicenseAnalysis?.validity || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Authority: ${data.tradeLicenseAnalysis?.authority || 'N/A'}`, 40, yPos);
    doc.text(`Renewal Due: ${data.tradeLicenseAnalysis?.renewalDue || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Activity: ${data.tradeLicenseAnalysis?.activity || 'N/A'}`, 40, yPos);
    doc.text(`Zoning: ${data.tradeLicenseAnalysis?.zoning || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Compliance Issues
    doc.setFontSize(14);
    doc.text("Compliance Issues", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Expired/Invalid: ${data.complianceIssues?.expiredInvalid || 'N/A'}`, 40, yPos);
    doc.text(`Frequent Re-registrations: ${data.complianceIssues?.frequentReregistrations || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Same GSTIN - Multiple Entities: ${data.complianceIssues?.sameGstinMultipleEntities || 'N/A'}`, 40, yPos);
    doc.text(`Litigation/Notices: ${data.complianceIssues?.litigationNotices || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Business Name Mismatch: ${data.complianceIssues?.businessNameMismatch || 'N/A'}`, 40, yPos);
    doc.text(`Zoning Violations: ${data.complianceIssues?.zoningViolations || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Analyst Evaluation Dashboard
    doc.setFontSize(14);
    doc.text("Analyst Evaluation Dashboard", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Legal ID: ${data.analystDashboard?.legalId || 'N/A'}`, 40, yPos);
    doc.text(`Business Registration: ${data.analystDashboard?.businessRegistration || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Compliance Regularity: ${data.analystDashboard?.complianceRegularity || 'N/A'}`, 40, yPos);
    doc.text(`Verification Completed: ${data.analystDashboard?.verificationCompleted || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Fit for Lending: ${data.analystDashboard?.fitForLending || 'N/A'}`, 40, yPos);
    doc.text(`Compliance Score: ${data.analystDashboard?.complianceScore || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Comments & Suggestions
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "Business license analysis completed based on available documentation.",
      "Registration verification and compliance assessment reviewed."
    ];
    comments.forEach(comment => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });
    yPos += 15;

    doc.setFontSize(14);
    doc.text("Suggestions", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const suggestions = data.suggestions || [
      "Maintain regular compliance with all business registrations.",
      "Keep all licenses and certificates updated for smooth operations.",
      "Monitor renewal dates to avoid any compliance gaps."
    ];
    suggestions.forEach(suggestion => {
      doc.text(`• ${suggestion}`, 40, yPos);
      yPos += 15;
    });

    doc.save("business-license-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const BusinessLicenseAnalyser = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-4 sm:p-6 text-sm space-y-6 min-h-screen max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Registration & License Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
         
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Business Entity Profile */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          💼 Business Entity Profile
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Legal Entity Name</strong>
            <span className="text-white">
              {getValue("businessEntity.legalName") ||
                getValue("business.legalName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Trade Name</strong>
            <span className="text-white">
              {getValue("businessEntity.tradeName") ||
                getValue("business.tradeName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Proprietor</strong>
            <span className="text-white">
              {getValue("businessEntity.proprietor") ||
                getValue("business.owner")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Constitution Type</strong>
            <span className="text-white">
              {getValue("businessEntity.constitutionType") ||
                getValue("business.type")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Nature of Business</strong>
            <span className="text-white">
              {getValue("businessEntity.natureOfBusiness") ||
                getValue("business.nature")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Date of Establishment</strong>
            <span className="text-white">
              {getValue("businessEntity.dateOfEstablishment") ||
                getValue("business.establishmentDate")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN</strong>
            <span className="text-white">
              {getValue("businessEntity.pan") || getValue("business.pan")}
            </span>
          </div>
          <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-3">
            <strong className="text-[#AAAAAA]">Business Address</strong>
            <span className="text-white">
              {getValue("businessEntity.businessAddress") ||
                getValue("business.address")}
            </span>
          </div>
        </div>
      </div>

      {/* Key Property Documents */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <FileText size={18} /> Key Property Documents – Availability & Status
        </div>
        <div className="overflow-x-auto scrollbar-hide">
          <div className="grid grid-cols-4 gap-4 mt-2 mb-3 min-w-[600px]">
            <h4 className="text-[#AAAAAA] font-semibold">Document Name</h4>
            <h4 className="text-[#AAAAAA] font-semibold">Available</h4>
            <h4 className="text-[#AAAAAA] font-semibold">
              Registration Number
            </h4>
            <h4 className="text-[#AAAAAA] font-semibold">Date of Issue</h4>
          </div>
          <div className="space-y-3 mt-2 min-w-[600px]">
            {(
              data.businessDocuments || [
                {
                  documentName: "GST Registration",
                  available: "Available",
                  registrationNumber: "27ABCDE1234F1Z5",
                  dateOfIssue: "15 Jan 2018",
                },
                {
                  documentName: "Udyam Certificate",
                  available: "Available",
                  registrationNumber: "UDYAM-DL-03-0012345",
                  dateOfIssue: "20 Mar 2020",
                },
                {
                  documentName: "Trade License",
                  available: "Available",
                  registrationNumber: "TL/2018/001234",
                  dateOfIssue: "10 Feb 2018",
                },
                {
                  documentName: "FSSAI License",
                  available: "Not Available",
                  registrationNumber: "-",
                  dateOfIssue: "-",
                },
                {
                  documentName: "Shop & Establishment",
                  available: "Available",
                  registrationNumber: "SE/2018/5678",
                  dateOfIssue: "25 Jan 2018",
                },
              ]
            ).map((doc, idx) => (
              <div key={idx} className="grid grid-cols-4 gap-4">
                <strong className="text-[#AAAAAA]">{doc.documentName}</strong>
                <span
                  className={
                    doc.available === "Available"
                      ? "text-green-400"
                      : "text-red-500"
                  }
                >
                  {doc.available}
                </span>
                <span className="text-white">{doc.registrationNumber}</span>
                <span className="text-white">{doc.dateOfIssue}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* GST Registration Analysis */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ClipboardCheck size={18} /> GST Registration Analysis
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">GSTIN</strong>
              <span className="text-white">
                {data.gstAnalysis?.gstin || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Jurisdiction</strong>
              <span className="text-white">
                {data.gstAnalysis?.jurisdiction || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Status</strong>
              <span className="text-green-400">
                {data.gstAnalysis?.status || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Return Compliance</strong>
              <span className="text-white">
                {data.gstAnalysis?.returnCompliance || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Registration Type</strong>
              <span className="text-white">
                {data.gstAnalysis?.registrationType || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Turnover</strong>
              <span className="text-white">
                ₹{data.gstAnalysis?.turnover?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Date of Registration</strong>
              <span className="text-white">
                {data.gstAnalysis?.dateOfRegistration || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Branches</strong>
              <span className="text-white">
                {data.gstAnalysis?.branches || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Udyam Certificate */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <BookOpenCheck size={18} /> MSME/Udyam Certificate Analysis
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Udyam No.</strong>
              <span className="text-white">
                {data.udyamAnalysis?.udyamNumber || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Sector</strong>
              <span className="text-white">
                {data.udyamAnalysis?.sector || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Date of Issue</strong>
              <span className="text-white">
                {data.udyamAnalysis?.dateOfIssue || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">PAN Linked</strong>
              <span className="text-white">
                {data.udyamAnalysis?.panLinked || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Classification</strong>
              <span className="text-white">
                {data.udyamAnalysis?.classification || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Business Activity</strong>
              <span className="text-white">
                {data.udyamAnalysis?.businessActivity || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Trade License */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Building2 size={18} /> Trade/Municipal License Analysis
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">License No</strong>
              <span className="text-white">
                {data.tradeLicenseAnalysis?.licenseNumber || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Validity</strong>
              <span className="text-white">
                {data.tradeLicenseAnalysis?.validity || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Authority</strong>
              <span className="text-white">
                {data.tradeLicenseAnalysis?.authority || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Renewal Due</strong>
              <span className="text-yellow-400">
                {data.tradeLicenseAnalysis?.renewalDue || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Activity</strong>
              <span className="text-white">
                {data.tradeLicenseAnalysis?.activity || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Zoning</strong>
              <span className="text-white">
                {data.tradeLicenseAnalysis?.zoning || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Compliance Issues */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ClipboardCheck size={18} /> Compliance Issues
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Expired/Invalid</strong>
              <span className="text-yellow-400">
                {data.complianceIssues?.expiredInvalid || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Frequent Re-registrations
              </strong>
              <span className="text-white">
                {data.complianceIssues?.frequentReregistrations || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Same GSTIN - Multiple Entities
              </strong>
              <span className="text-white">
                {data.complianceIssues?.sameGstinMultipleEntities || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Litigation/Notices</strong>
              <span className="text-white">
                {data.complianceIssues?.litigationNotices || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Business Name Mismatch</strong>
              <span className="text-white">
                {data.complianceIssues?.businessNameMismatch || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Zoning Violations</strong>
              <span className="text-white">
                {data.complianceIssues?.zoningViolations || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Analyst Dashboard */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ShieldCheck size={18} /> Analyst Evaluation Dashboard
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Legal ID</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.analystDashboard?.legalId || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Business Registration</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.analystDashboard?.businessRegistration || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Compliance Regularity</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.analystDashboard?.complianceRegularity || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Verification Completed</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.analystDashboard?.verificationCompleted || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Fit for Lending</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.analystDashboard?.fitForLending || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Compliance Score</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.analystDashboard?.complianceScore || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-green-950 border border-green-600 rounded-lg p-4 text-green-400">
          <h3 className="font-semibold text-green-500 mb-2">
            ✔ Final Comments
          </h3>
          <ul className="list-disc pl-5 space-y-1">
            {data.finalComments?.map((comment, index) => (
              <li key={index}>{comment}</li>
            )) || [
              <li key="default1">
                Business license analysis completed based on available
                documentation.
              </li>,
              <li key="default2">
                Registration verification and compliance assessment reviewed.
              </li>,
            ]}
          </ul>
        </div>
        <div className="bg-yellow-900 border border-yellow-600 rounded-lg p-4 text-yellow-300">
          <h3 className="font-semibold mb-2">💡 Suggestions</h3>
          <ul className="list-disc pl-5 space-y-1">
            {data.suggestions?.map((suggestion, index) => (
              <li key={index}>{suggestion}</li>
            )) || [
              <li key="default1">
                Maintain regular compliance with all business registrations.
              </li>,
              <li key="default2">
                Keep all licenses and certificates updated for smooth
                operations.
              </li>,
              <li key="default3">
                Monitor renewal dates to avoid any compliance gaps.
              </li>,
            ]}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BusinessLicenseAnalyser;
